import { useDefaultPrompt } from 'hooks';
import { useFormContext } from 'libs/form/useFormContext';

export const useFormPrompt = (onConfirm?: () => void) => {
  const { readOnly, dirty, isSubmitting } = useFormContext();
  return useDefaultPrompt({ readOnly, dirty, isSubmitting }, onConfirm);
};
